import { z } from 'zod';

const OneDayInMillis = 24 * 60 * 60 * 1000;

// syslog level names — winston is configured with winston.config.syslog.levels,
// so 'warn', 'verbose' and 'trace' are NOT valid levels here.
export const LogLevelSchema = z.enum(['error', 'warning', 'info', 'debug']);

export type LogLevel = z.infer<typeof LogLevelSchema>;

/** Shape stored in redis while an override is active. The redis TTL is the auto-reset. */
export const LogLevelOverrideSchema = z.object({
  level: LogLevelSchema,
  setBy: z.string(),
});

export type LogLevelOverride = z.infer<typeof LogLevelOverrideSchema>;

export const SetLogLevelBodySchema = z.object({
  level: LogLevelSchema,
  durationMs: z.number().int().positive().max(OneDayInMillis),
});

export type SetLogLevelBody = z.infer<typeof SetLogLevelBodySchema>;

export const LogLevelStateSchema = z.object({
  /** effective level right now */
  level: LogLevelSchema,
  /** env LOG_LEVEL — what an expiry or reset returns to */
  baseline: LogLevelSchema,
  /** null when no override is active */
  setBy: z.string().nullable(),
  resetsInMs: z.number().nullable(),
});

export type LogLevelState = z.infer<typeof LogLevelStateSchema>;
